import script from "./PhysicalExaminationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PhysicalExaminationForm.vue?vue&type=script&setup=true&lang=js"

import "./PhysicalExaminationForm.vue?vue&type=style&index=0&id=6bf61b44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf61b44"]])

export default __exports__